var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4078 1.56198C25.5611 0.558148 26.5005 -0.131036 27.5043 0.0210194C28.5088 0.17432 29.1986 1.1131 29.0453 2.1176L23.6491 37.4382C23.5099 38.3482 22.7262 39 21.8328 39C21.7401 39 21.647 38.9932 21.5525 38.9791C20.5481 38.8258 19.8583 37.8869 20.0116 36.8825L25.4078 1.56198ZM14.522 30.2563L4.3698 19.5L14.522 8.74386C15.2192 8.00495 15.1855 6.84044 14.4466 6.1433C13.7082 5.44607 12.5431 5.4798 11.846 6.21871L0.501725 18.2375C-0.167242 18.9463 -0.167242 20.0544 0.501725 20.7633L11.8466 32.7827C12.2084 33.166 12.6959 33.3591 13.1846 33.3591C13.6371 33.3591 14.0916 33.1923 14.4466 32.8569C15.1861 32.1596 15.2192 30.9952 14.522 30.2563ZM48.5542 18.2379L37.2099 6.21914C36.5127 5.47965 35.3489 5.44593 34.6094 6.14373C33.871 6.84097 33.8367 8.00538 34.5345 8.74429L44.6874 19.4999L34.5345 30.2567C33.8367 30.9956 33.871 32.1595 34.6094 32.8573C34.965 33.1927 35.4194 33.3589 35.872 33.3589C36.3607 33.3589 36.8488 33.1651 37.21 32.783L48.5543 20.7637C49.2232 20.0543 49.2232 18.9468 48.5542 18.2379Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.1c6c9db9.svg";
export { ForwardRef as ReactComponent };